import rotowireLogo from '#src/assets/icons/rotowireLogo.webp';
import { unitMapping, type Unit } from '#src/lib/style.ts';

export const RotowireSmallLogo = ({ size }: { size: Unit }) => (
  <img style={{ width: unitMapping[size] }} src={rotowireLogo} alt="" />
);
